/**
 * Popup JavaScript
 *
 * This file defines behaviors of
 * the Popup block.
 */
import onReady from '../util/on-ready'

const openPopup = (popup, id, prevFocus) => {
	// set the hash (so we can link to it)
	window.history.pushState(null, null, `#${id}`)
	// move this to the end of the body if we've not already
	if (!popup.classList.contains('popup--root')) {
		popup.classList.add('popup--root')
		popup.querySelector('.popup__frame')
		popup.setAttribute('tabindex', '0')
		document.body.appendChild(popup)
	}

	// handle close
	const closer = popup.querySelector('.js-popup-close')
	const handleClose = () => {
		// hide the current popup
		popup.classList.remove('active')
		document.body.classList.remove('popup-active')
		// remove hash
		window.history.replaceState(null, null, ' ')
		// refocus on original target
		prevFocus?.focus()
		// remove this listener recursively
		closer.removeEventListener('click', handleClose)
	}
	closer.addEventListener('click', handleClose)
	// wait just a moment in case this just got moved (for animations)
	setTimeout(() => {
		// visually show the popup
		popup.classList.add('active')
		document.body.classList.add('popup-active')
		// focus on it for accessibility
		popup.focus()
	}, 10)
}

const handlePopupClicks = (e) => {
	// if a popup link got clicked
	if (e.target?.href && e.target?.href.includes('#popup-')) {
		// get target ID
		const id = e.target.href.split('#')?.pop()
		// get target by ID
		const popup = document.getElementById(id)
		// if we have a popup
		if (popup && popup.classList.contains('js-popup')) {
			// don't jump anywhere
			e.preventDefault()
			// open the popup
			openPopup(popup, id, e.target)
		}
	}
}

const handlePopupLoad = () => {
	// if we have a hash then open the popup
	if (window.location?.hash?.includes('#popup-')) {
		const id = window.location.hash.split('#').pop()
		// get target by ID
		const popup = document.getElementById(id)
		if (popup && popup.classList.contains('js-popup')) {
			// open the popup
			openPopup(popup, id)
		}
	}
}

export const popupSetup = () => {
	document.addEventListener('click', handlePopupClicks)
	onReady(handlePopupLoad)
}
